import { RoadMapItem } from './RoadMapItem'

export class BaseRoadmapItem extends RoadMapItem {
    y: number
    x: number
    constructor(type: number, x: number, y: number) {
        super(type)
        this.x = x
        this.y = y
    }
}
